import {
    PartsProductOptions,
    PartsProductOptionsFeatherKindEnum as Kind,
} from '@app/react/const/type';

export const isDisableFeatherinside = (featherOpt: PartsProductOptions): boolean => (
    (featherOpt?.featherKind ?? Kind.Normal) === Kind.None
);
